import { supabaseClient } from './supabase';
import { toast as message } from 'sonner';

/**
 * Fetches a short-lived signed URL for a file object.
 * Returns the URL string or null on failure.
 */
export async function getSignedUrl(fileObjectId: string | number): Promise<string | null> {
  try {
    const { data, error } = await supabaseClient.functions.invoke('file-signed-url', {
      body: { file_object_id: fileObjectId },
    });
    if (error || !data?.url) return null;
    return data.url;
  } catch {
    return null;
  }
}

/**
 * Opens a file in a new tab via signed URL.
 */
export async function openFileById(fileObjectId: string | number, filename: string): Promise<void> {
  const url = await getSignedUrl(fileObjectId);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    message.error(`Could not open ${filename}`);
  }
}
